export function buildMenuTree(flatList) {
  if (!flatList || !flatList.length) return []
  const map = {}
  flatList.forEach(item => {
    map[item.id] = { ...item, children: [] }
  })
  const roots = []
  flatList.forEach(item => {
    const node = map[item.id]
    const parentId = item.parentId || 0
    if (parentId && map[parentId]) {
      map[parentId].children.push(node)
    } else {
      roots.push(node)
    }
  })
  return roots
}
